<template>
  <div id="UserView" class="box">
    <div class="box-tittel">      
        <h1 class="text-center">{{this.tittle}}</h1>      
    </div>
    <div class="box-list">
      <UserListComponent :userList="$store.getters.getUsers"/>
    </div>
    <!--div class="box-45">
      <UserFormComponent 
      :us="$store.getters.getUserSelected" 
      :update="$store.getters.getIsUpdate"        
      />
    </div-->
  </div>
</template>
<script >
import UserListComponent from "./../components/user/UserList.vue";

export default {
  name: "Users",
  components: {
    UserListComponent,   
  },
  data() {
    return {
      tittle: "Usuarios",
    };
  }, 
  
};
</script>
<style>
#UserView {
  /*display: flexbox;*/
  /*background-color: #49a1a1;*/
  min-height: 100vh;
  width: 100%;
  height: 100%; 
}
</style>